import queryString, { StringifiableRecord } from "query-string";

export function stringifyUrl({
  url,
  query,
}: {
  url: string;
  query: StringifiableRecord;
}) {
  return queryString.stringifyUrl(
    {
      url,
      query,
    },
    {
      skipNull: true,
    },
  );
}

const routes = {
  home: "/",
  review: "/review",
  example_request: "/example/request",
  example_locale: "/example/locale",
};

export default routes;
